import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import { H2, H5, Subtitle2, Body1, Body2 } from 'components/Typography';
import { Mobile, Default } from 'components/Responsive';
import styles from './styles';
import { fromISOFormat, toShortDateString } from 'utilities/formatters/dateTimeFormatter';
import m from 'messages';
import {
    competenceTitle,
    zoneTitle,
    groupCompetencies
} from 'areas/competence/domain';

class Competencies extends React.Component {
    render() {
        const { card, classes, filter, invertedFilter, displayProp, title } = this.props;

        const titleFunc = displayProp === 'zoneName' ? zoneTitle : competenceTitle;
        const competencyMap = groupCompetencies(card.competencies, filter, invertedFilter);

        return (
            <div>
                <H2 paragraph>
                    {title}
                </H2>
                {Array.from(competencyMap.keys()).map((group, index) =>
                    <div key={index}>
                        <Grid container>
                            <Grid item xs={12}>
                                <H5 className={classes.groupHeader}>
                                    {group}
                                </H5>
                            </Grid>
                            <Default>
                                <Grid item sm={8}>
                                    <Subtitle2 className={classes.gridHeader}>
                                        {m.cards.competencyTitle}
                                    </Subtitle2>
                                </Grid>
                                <Grid item sm={4}>
                                    <Subtitle2 className={classes.gridHeader}>
                                        {m.cards.competencyExpiryDate}
                                    </Subtitle2>
                                </Grid>
                            </Default>
                            {competencyMap.get(group).map((comp, index) =>
                                <Grid item xs={12} key={index}>
                                    <Grid container>
                                        <Mobile>
                                            <Grid item xs={12} sm={6}>
                                                <Subtitle2>
                                                    {m.cards.competencyTitle}
                                                </Subtitle2>
                                                <Body1>
                                                    {titleFunc(comp, filter, displayProp)}
                                                </Body1>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Subtitle2>
                                                    {m.cards.competencyExpiryDate}
                                                </Subtitle2>
                                                <Body2>
                                                    {comp.expiryDate.startsWith("9999") ? "Does not expire" : toShortDateString(fromISOFormat(comp.expiryDate))}
                                                </Body2>
                                            </Grid>
                                        </Mobile>
                                        <Default>
                                            <Grid item sm={8}>
                                                <Body1>
                                                    {titleFunc(comp, filter, displayProp)}
                                                </Body1>
                                            </Grid>
                                            <Grid item sm={4}>
                                                <Body2>
                                                    {comp.expiryDate.startsWith("9999") ? "Does not expire" : toShortDateString(fromISOFormat(comp.expiryDate))}
                                                </Body2>
                                            </Grid>
                                        </Default>
                                    </Grid>
                                    <Divider className={classes.divider} />
                                </Grid>
                            )}
                        </Grid>
                    </div>
                )}
            </div>
        );
    }
}

Competencies.propTypes = {
    card: PropTypes.object.isRequired,
    filter: PropTypes.string,
    displayProp: PropTypes.string,
    title: PropTypes.string.isRequired
};
export default withStyles(Competencies,styles);
